import { FormattedMessage, useIntl } from 'react-intl';
import { FilterItem } from '@molecules/filters/filtersMenu';
import { FilterGeneral } from '@libs/store/filters';

type StaffingTypeFilterMenuProps = {
  localizationSubset: string;
  getFilter: (key: string) => FilterGeneral<string[]> | null;
  key: string;
};
export function useStaffingTypeFilterMenu({
  localizationSubset,
  getFilter,
  key,
}: StaffingTypeFilterMenuProps): FilterItem {
  const intl = useIntl();
  const filter = getFilter(key);

  return {
    label: <FormattedMessage id={`${localizationSubset}.filters.${key}.label`} />,
    key: key,
    valueToLabel: (value) =>
      value.map((v) => intl.formatMessage({ id: `shifts.stuffingType.${v.toLowerCase()}` })).join(', '),
    children: [
      {
        label: <FormattedMessage id="shifts.stuffingType.internal" />,
        key: 'Internal',
      },
      {
        label: <FormattedMessage id="shifts.stuffingType.external" />,
        key: 'External',
      },
    ].map((item) => ({
      ...item,
      selected: filter?.value.includes(item.key) || false,
    })),
  };
}
